// client/src/components/comunicacao/shared/PeriodoEnvioFields.js
import React from 'react';
import PropTypes from 'prop-types';

// ✅ Campos compartilhados de "quando enviar" (mesmo formato de
// server/models/subschemas/PeriodoEnvioSchema.js) — reusado por
// TemplateMensagemForm.js (periodoEnvioPadrao) e ComunicacaoAutomaticaForm.js
// (override opcional). 'antes'/'depois' só fazem sentido quando ligados a um
// Agendamento (deslocamento de dataInicio/dataFim) — permitirAntesDepois=false
// esconde essas opções para os demais domínios (Pedido/Sistema/Cliente).
const DIAS_SEMANA = [
    { value: 0, label: 'Dom' },
    { value: 1, label: 'Seg' },
    { value: 2, label: 'Ter' },
    { value: 3, label: 'Qua' },
    { value: 4, label: 'Qui' },
    { value: 5, label: 'Sex' },
    { value: 6, label: 'Sáb' },
];

const PeriodoEnvioFields = ({ value, onChange, permitirAntesDepois, idPrefix }) => {
    const periodo = value || { momento: 'imediato', offsetMinutos: 0, diasSemana: [], janelaHorario: { inicio: null, fim: null } };

    const handleMomentoChange = (momento) => {
        onChange({ ...periodo, momento });
    };

    const handleOffsetChange = (offsetMinutos) => {
        onChange({ ...periodo, offsetMinutos: Math.max(0, Number(offsetMinutos) || 0) });
    };

    const toggleDiaSemana = (dia) => {
        const diasAtuais = periodo.diasSemana || [];
        const novosDias = diasAtuais.includes(dia)
            ? diasAtuais.filter((d) => d !== dia)
            : [...diasAtuais, dia].sort();
        onChange({ ...periodo, diasSemana: novosDias });
    };

    const handleJanelaChange = (campo, valor) => {
        onChange({
            ...periodo,
            janelaHorario: { ...(periodo.janelaHorario || {}), [campo]: valor || null }
        });
    };

    return (
        <div className="form-grid-container-cols-2">
            <div className="form-group">
                <label htmlFor={`${idPrefix}-momento`}>Quando Enviar</label>
                <select
                    id={`${idPrefix}-momento`}
                    value={periodo.momento || 'imediato'}
                    onChange={(e) => handleMomentoChange(e.target.value)}
                    className="form-input"
                >
                    <option value="imediato">Na hora (imediato)</option>
                    {permitirAntesDepois && <option value="antes">Antes do agendamento</option>}
                    {permitirAntesDepois && <option value="depois">Depois do agendamento</option>}
                </select>
            </div>

            {periodo.momento !== 'imediato' && (
                <div className="form-group">
                    <label htmlFor={`${idPrefix}-offset`}>
                        Minutos {periodo.momento === 'antes' ? 'antes' : 'depois'}
                    </label>
                    <input
                        type="number"
                        id={`${idPrefix}-offset`}
                        min="0"
                        value={periodo.offsetMinutos ?? 0}
                        onChange={(e) => handleOffsetChange(e.target.value)}
                        className="form-input"
                    />
                </div>
            )}

            <div className="form-group full-width">
                <label>Dias da Semana</label>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.25rem' }}>
                    {DIAS_SEMANA.map((dia) => {
                        const ativo = (periodo.diasSemana || []).includes(dia.value);
                        return (
                            <button
                                key={dia.value}
                                type="button"
                                onClick={() => toggleDiaSemana(dia.value)}
                                className={`action-button ${ativo ? 'action-button-primary' : 'action-button-secondary'}`}
                                style={{ padding: '0.35rem 0.75rem' }}
                            >
                                {dia.label}
                            </button>
                        );
                    })}
                </div>
                <small className="form-help">Nenhum dia selecionado = qualquer dia da semana</small>
            </div>

            <div className="form-group">
                <label htmlFor={`${idPrefix}-hora-inicio`}>Horário Permitido — Início</label>
                <input
                    type="time"
                    id={`${idPrefix}-hora-inicio`}
                    value={periodo.janelaHorario?.inicio || ''}
                    onChange={(e) => handleJanelaChange('inicio', e.target.value)}
                    className="form-input"
                />
            </div>

            <div className="form-group">
                <label htmlFor={`${idPrefix}-hora-fim`}>Horário Permitido — Fim</label>
                <input
                    type="time"
                    id={`${idPrefix}-hora-fim`}
                    value={periodo.janelaHorario?.fim || ''}
                    onChange={(e) => handleJanelaChange('fim', e.target.value)}
                    className="form-input"
                />
                <small className="form-help">Deixe ambos em branco para qualquer horário</small>
            </div>
        </div>
    );
};

PeriodoEnvioFields.propTypes = {
    value: PropTypes.shape({
        momento: PropTypes.oneOf(['imediato', 'antes', 'depois']),
        offsetMinutos: PropTypes.number,
        diasSemana: PropTypes.arrayOf(PropTypes.number),
        janelaHorario: PropTypes.shape({
            inicio: PropTypes.string,
            fim: PropTypes.string,
        }),
    }),
    onChange: PropTypes.func.isRequired,
    permitirAntesDepois: PropTypes.bool,
    idPrefix: PropTypes.string,
};

PeriodoEnvioFields.defaultProps = {
    value: null,
    permitirAntesDepois: true,
    idPrefix: 'periodo-envio',
};

export default PeriodoEnvioFields;
